import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeedItem = ({ activity }) => {
  const getActivityIcon = () => {
    const iconMap = {
      quiz_completed: 'CheckCircle',
      play_started: 'Play',
      badge_earned: 'Award',
      user_registered: 'UserPlus',
      content_uploaded: 'Upload',
      glossary_added: 'BookText'
    };
    return iconMap?.[activity?.type] || 'Activity';
  };

  const getActivityColor = () => {
    const colorMap = {
      quiz_completed: 'text-success',
      play_started: 'text-accent',
      badge_earned: 'text-secondary',
      user_registered: 'text-primary',
      content_uploaded: 'text-warning',
      glossary_added: 'text-accent'
    };
    return colorMap?.[activity?.type] || 'text-foreground';
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  return (
    <div className="flex items-start gap-4 p-4 hover:bg-muted rounded-lg transition-colors duration-150">
      <div className="flex-shrink-0">
        {activity?.userAvatar ? (
          <Image 
            src={activity?.userAvatar} 
            alt={activity?.userAvatarAlt}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
            {activity?.userName?.charAt(0)?.toUpperCase() || 'U'}
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start gap-2 mb-1">
          <Icon name={getActivityIcon()} size={16} className={getActivityColor()} />
          <p className="text-sm text-card-foreground">
            <span className="font-semibold">{activity?.userName}</span> {activity?.description}
          </p>
        </div>
        <p className="text-xs text-muted-foreground">{formatTimestamp(activity?.timestamp)}</p>
      </div>
    </div>
  );
};

export default ActivityFeedItem;